import React, { useMemo } from 'react';

import { Row, Form, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';

import { Button } from '../../../components';
import { generateReport, getReportData, removeReportData } from '../operations';
import { customStyles } from '../utils';

import './styles.scoped.css';

const DriverSearchForm = ({
  setForm,
  form,
  setLoadingResults,
  setData,
  setShowResults,
  driverStatuses,
  isLoadingStatuses,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user } = useSelector(state => state.admin);

  const viewFullPii = useMemo(
    () => user?.appAccess?.items?.find(item => item.appId.id === '4')?.roleId?.viewFullPii,
    [user],
  );

  const handleViewResults = async () => {
    setLoadingResults(true);
    const { EmpStatus, EmplLastName, EmplFirstName, EmpId, ReportFormat } = form;
    try {
      const response = await generateReport({
        endpoint: 'driver-search-report',
        payload: {
          EmpStatus,
          EmplLastName,
          EmplFirstName,
          EmpId,
          ReportFormat,
          viewFullPii,
        },
      });
      if (response.location && response.location !== '') {
        const reportData = await getReportData(response.location);
        if (reportData?.length) {
          await removeReportData(response.location);
          setLoadingResults(false);
          setData(reportData);
          setShowResults(true);
        }
      } else {
        setLoadingResults(false);
        setLoadingResults(false);
        // eslint-disable-next-line no-undef
        alert('No data found matching your criteria.');
      }
    } catch (error) {
      console.log(error);
      setLoadingResults(false);
    }
  };

  const handleChange = e => {
    const _form = { ...form, [e.target.name]: e.target.value };
    setForm(_form);
  };
  return (
    <Form
      noValidate
      onSubmit={() => {}}
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}>
      <div className="filters-row">
        <div className="filter-row">
          <Form.Group as={Row} controlId="EmpStatus" style={{ alignItems: 'center' }}>
            <Form.Label style={{ width: '290px' }}>{`${t('edge_reporting.driver_search.driver')} Status`}</Form.Label>
            <div className="dropdown-spinner-container">
              <Select
                isMulti
                closeMenuOnSelect={false}
                styles={customStyles('360px')}
                options={driverStatuses}
                isClearable
                onChange={selectedOptions => {
                  const selectedCodes = selectedOptions.map(option => option.value);
                  setForm({
                    ...form,
                    EmpStatus: selectedCodes.join(','),
                  });
                }}
                value={form?.EmpStatus?.split(',').map(code => driverStatuses.find(option => option.value === code))}
              />
              {isLoadingStatuses && (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  aria-hidden="true"
                  className="dropdown-spinner"
                />
              )}
            </div>
          </Form.Group>
        </div>
        <div className="filter-row">
          <Form.Group as={Row} controlId="EmplLastName" style={{ alignItems: 'center' }}>
            <Form.Label
              style={{ width: '290px' }}>{`${t('edge_reporting.driver_search.driver')} Last Name`}</Form.Label>
            <Form.Control
              style={{
                width: '360px',
                height: '30px',
                marginRight: '20px',
              }}
              as="input"
              name="EmplLastName"
              value={form?.EmplLastName}
              onChange={handleChange}
            />
          </Form.Group>
        </div>

        <div className="filter-row">
          <Form.Group as={Row} controlId="EmplFirstName" style={{ alignItems: 'center' }}>
            <Form.Label
              style={{ width: '290px' }}>{`${t('edge_reporting.driver_search.driver')} First Name`}</Form.Label>
            <Form.Control
              style={{
                width: '360px',
                height: '30px',
                marginRight: '20px',
              }}
              as="input"
              name="EmplFirstName"
              value={form?.EmplFirstName}
              onChange={handleChange}
            />
          </Form.Group>
        </div>

        <div className="filter-row">
          <Form.Group as={Row} style={{ alignItems: 'center' }}>
            <Form.Label style={{ width: '290px' }}>{`${t('edge_reporting.driver_search.driver')} Number`}</Form.Label>
            <Form.Control
              style={{
                width: '360px',
                height: '30px',
                marginRight: '20px',
              }}
              as="input"
              type="number"
              name="EmpId"
              value={form?.EmpId}
              onChange={handleChange}
            />
          </Form.Group>
        </div>
        <div className="filter-row">
          <Form.Group as={Row} controlId="ReportFormat" style={{ alignItems: 'center' }}>
            <Form.Label style={{ width: '290px' }}>Report Format</Form.Label>
            <div className="dropdown-spinner-container">
              <Select
                styles={customStyles('360px')}
                options={[
                  { label: 'Detail', value: 'Detail' },
                  { label: 'Summary', value: 'Summary' },
                ]}
                isClearable
                onChange={(selectedOption, action) => {
                  const _form = {
                    ...form,
                    ReportFormat: action.action === 'clear' ? '' : selectedOption.value,
                  };
                  setForm(_form);
                }}
                name="ReportFormat"
                value={{
                  label: form?.ReportFormat,
                  value: form?.ReportFormat,
                }}
              />
            </div>
          </Form.Group>
        </div>
      </div>
      <div className="buttons-row">
        <Button variant="primary" onClick={() => handleViewResults()} style={{ marginRight: '20px', width: '100px' }} text="View" />

        <Button
          style={{ width: '100px' }}
          onClick={() => navigate('/edge-reporting')}
          variant="outline"
          text="Cancel"
        />
      </div>
    </Form>
  );
};

export default DriverSearchForm;
